import { SortType } from '@/models/SortType';
import { TableHeader } from '@/models/TableHeader';
import dayjs from 'dayjs';
import { DOEDTO } from '@/models/DOEDTO';

export interface DoeState {
    tableHeader: TableHeader[];
    page: number;
    nbOfPages: number;
    scroll: number;
    count: number,
    does: DOEDTO[];
    sort?: {
        sortData: string;
        sortStatus: SortType;
    };
    isDoeLoading: boolean;
    isPdfLoading: boolean;
    filterDocumentDateFrom: string;
    filterDocumentDateTo: string;
    nbDoe?: number;
}

export const initialState: DoeState = {
    does: [],
    tableHeader: [
        {
            label: 'doe.table.libelle',
            sortData: 'libelleDoe',
            sortStatus: SortType.NONE,
            width: '25%',
        },
        {
            label: 'doe.table.projet',
            sortData: 'chantierTitre',
            sortStatus: SortType.NONE,
            width: '30%',
        },
        {
            label: 'doe.table.site',
            sortData: 'site',
            sortStatus: SortType.NONE,
            width: '25%',
        },
        {
            label: 'doe.table.date.mise.a.jour',
            sortData: 'dateDerniereModification',
            sortStatus: SortType.NONE,
            width: '15%',
        },
        {    label: '',
            sortData: '',
            sortStatus: SortType.INACTIVE,
            width: '5%',
        },

    ],
    page: 0,
    nbOfPages: 0,
    scroll: 0,
    count: 0,

    sort: {
        sortData: 'dateDerniereModification',
        sortStatus: SortType.DESC,
    },
    filterDocumentDateFrom: dayjs().startOf('year').format('YYYY-MM-DD'),
    filterDocumentDateTo: dayjs().endOf('year').format('YYYY-MM-DD'),

    isDoeLoading: false,
    isPdfLoading: false,
};

export const state: DoeState = {
    ...initialState
};
